export default __webpack_public_path__ + "static/media/google_dk.e31304ae.png";